module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-rollbar/gatsby-browser.js'),
      options: {"plugins":[],"accessToken":"9f05658d775b4c5e8b704a0a452b5925","captureUncaught":false,"captureUnhandledRejections":false,"payload":{"environment":"production","client":{"javascript":{"code_version":"2.0.0","source_map_enabled":false,"guess_uncaught_frames":false}}}},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Iziwork","short_name":"Iziwork","start_url":"/","background_color":"#031b4a","theme_color":"#031b4a","display":"minimal-ui","icon":"static/img/logo-icon.svg","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"7ade16f4a515c896b19b6c2c00331a19"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
